module.exports = __webpack_public_path__ + "static/media/start.68a5d6c4.mp3";